
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

function getSteps() {
    return ['Pick what to personalize', 'Select personalized content', 'Review & confirm'];
}

const styles = theme => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    }
});

class Step1 extends React.Component {
    static propTypes = {
        classes: PropTypes.object,
    };

    state = {
        activeStep: 0,
    };

    render() {
        const { classes } = this.props;
        const steps = getSteps();
        const { activeStep } = this.state;

        return (
            <Grid container spacing={24}>
                <Grid item xs={6}>
                    <Card style={{ cursor: 'pointer' }} onClick={() => this.setState({ activeStep: 0 })} color={this.state.activeStep === 0 ? "" : "textSecondary"}>
                        <CardContent>
                            <Typography variant={this.state.activeStep === 0 ? "headline" : "subheading"}>
                                Add a new component
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6}>
                    <Card style={{ cursor: 'pointer' }} onClick={() => this.setState({ activeStep: 1 })}>
                        <CardContent>
                            <Typography variant={this.state.activeStep === 1 ? "headline" : "subheading"} color={this.state.activeStep === 1 ? "" : "textSecondary"}>
                                Select existing component
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(Step1);


// WEBPACK FOOTER //
// ./src/components/personalization/Step1.js